import { pharmacyClient } from "@/connect";

export const getPurchaseRequests = async (page: number, pageSize: number) => {
  return await pharmacyClient.listPurchaseRequests({
    page: page,
    pageSize: pageSize,
  });
};